import { ComparatorStep } from '@kizi/comparator-core';

const partnerDependancies = [
  {
    name: 'hasPartner',
    condition: { fn: 'isEqual', args: ['1'] },
    active: true,
  },
  {
    name: 'hasPartner',
    condition: { fn: 'isEqual', args: ['0'] },
    active: false,
  },
];

const options = [
  { label: 'Jongen', value: 'male' },
  { label: 'Meisje', value: 'female' },
];

const getUserInput: ComparatorStep = {
  path: 'funnel',
  name: 'getUserInput',
  fields: [
    {
      name: 'postcode',
      validator: [
        {
          fn: 'regex',
          args: ['Voer een geldige postcode in', '^[0-9]{4}[a-z]{2}$', 'i'],
        },
      ],
      transformers: ['removeSpaces', 'uppercase'],
      active: true,
    },
    {
      name: 'postcodeAffiliates',
      validator: [
        {
          fn: 'regex',
          args: ['Voer een geldige postcode in', '^[0-9]{4}[a-z]{2}$', 'i'],
        },
      ],
      transformers: ['removeSpaces', 'uppercase'],
    },
    {
      name: 'housenumber',
      validator: [
        {
          fn: 'required',
          args: ['Voer een geldig huisnummer in'],
        },
        {
          fn: 'houseNumberIsValid',
          args: [
            'Deze combinatie van postcode/huisnummer kennen we helaas niet.',
          ],
        },
      ],
      transformers: {
        fn: 'replaceWith',
        args: ['[^0-9-]+', ''],
      },
    },
    {
      name: 'housenumberaddition',
    },
    {
      name: 'street',
    },
    {
      name: 'city',
    },
    {
      name: 'fullAddress',
    },
    {
      name: 'genderAffiates',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options: [
        { label: 'Man', value: 'male' },
        { label: 'Vrouw', value: 'female' },
      ],
    },
    {
      name: 'birthdate',
      validator: [
        {
          fn: 'required',
          args: ['Dit veld is verplicht'],
        },
        {
          fn: 'isOlderThan',
          args: [
            {
              invalidDate:
                'Vul hier een geldige geboortedatum in. (vb. 01-01-1970)',
              tooYoung: 'Je kunt een aanvraag doen vanaf 18 jaar',
              tooOld: 'Je kunt een aanvraag doen tot 100 jaar',
            },
            18,
          ],
        },
      ],
      transformers: ['normalizeDate', 'numericToDate'],
      active: true,
    },
    {
      name: 'gender',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options: [
        { label: 'Man', value: 'male' },
        { label: 'Vrouw', value: 'female' },
      ],
      active: true,
    },
    {
      name: 'isStudent',
      label: 'Ik ben een student',
      value: '0',
    },
    {
      name: 'hasPartner',
      value: '0',
    },
    {
      name: 'childGender1',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options,
      active: false,
      dependsOn: [
        {
          name: 'birthdateContextFields',
          condition: {
            fn: 'isArrayLengthGreater',
            args: [0],
          },
          active: true,
        },
      ],
    },
    {
      name: 'childGender2',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options,
      active: false,
      dependsOn: [
        {
          name: 'birthdateContextFields',
          condition: {
            fn: 'isArrayLengthGreater',
            args: [1],
          },
          active: true,
        },
      ],
    },
    {
      name: 'childGender3',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options,
      active: false,
      dependsOn: [
        {
          name: 'birthdateContextFields',
          condition: {
            fn: 'isArrayLengthGreater',
            args: [2],
          },
          active: true,
        },
      ],
    },
    {
      name: 'childGender4',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options,
      active: false,
      dependsOn: [
        {
          name: 'birthdateContextFields',
          condition: {
            fn: 'isArrayLengthGreater',
            args: [3],
          },
          active: true,
        },
      ],
    },
    {
      name: 'childGender5',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options,
      active: false,
      dependsOn: [
        {
          name: 'birthdateContextFields',
          condition: {
            fn: 'isArrayLengthGreater',
            args: [4],
          },
          active: true,
        },
      ],
    },
    {
      name: 'optionalemail',
      label: 'E-mailadres',
      validator: {
        fn: 'isValidEmail',
        args: ['U heeft een niet-bestaand e-mailadres ingevuld.'],
      },
    },
    {
      name: 'partnerGender',
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht'],
      },
      options: [
        { label: 'Man', value: 'male' },
        { label: 'Vrouw', value: 'female' },
      ],
      active: false,
      dependsOn: partnerDependancies,
    },
    {
      name: 'childBirthdate1',
      transformers: ['normalizeDate', 'numericToDate'],
    },
    {
      name: 'childBirthdate2',
      transformers: ['normalizeDate', 'numericToDate'],
    },
    {
      name: 'childBirthdate3',
      transformers: ['normalizeDate', 'numericToDate'],
    },
    {
      name: 'childBirthdate4',
      transformers: ['normalizeDate', 'numericToDate'],
    },
    {
      name: 'childBirthdate5',
      transformers: ['normalizeDate', 'numericToDate'],
    },
    {
      name: 'numberOfChildren',
      value: 0,
    },
    {
      name: 'partnerBirthdate',
      validator: [
        {
          fn: 'required',
          args: ['Dit veld is verplicht'],
        },
        {
          fn: 'isOlderThan',
          args: [
            {
              invalidDate:
                'Vul hier een geldige geboortedatum in. (vb. 01-01-1970)',
              tooYoung: 'Je kunt een aanvraag doen vanaf 18 jaar',
              tooOld: 'Je kunt een aanvraag doen tot 100 jaar',
            },
            18,
            100,
          ],
        },
      ],
      transformers: ['normalizeDate', 'numericToDate'],
      active: false,
      dependsOn: partnerDependancies,
    },
    {
      name: 'birthdateContextFields',
      value: '[]',
    },
    {
      name: 'insuredFamilyComposition',
      value: 'VA',
    },
    {
      name: 'coverageadditions',
    },
    {
      name: 'defaultCoverages',
      value: '',
    },
    {
      name: 'activeDecisionAid',
      value: '',
    },
    {
      name: 'activeCoverageItem',
      value: '',
    },
    {
      name: 'Tandheelkundige_hulp_vanaf_18_jaar',
      value: '',
    },
    {
      name: 'Fysiotherapie',
      value: '',
    },
    {
      name: 'Zwangerschap_en_bevalling',
      value: '',
    },
    {
      name: 'Brillen_en_lenzen',
      value: '',
    },
    {
      name: 'Hulp_in_het_buitenland',
      value: '',
    },
    {
      name: 'ORTO',
      value: '',
    },
    {
      name: 'Alternatieve_geneeswijzen',
      value: '',
    },
    {
      name: 'Anticonceptie',
      value: '',
    },
    {
      name: 'HT',
      value: '',
    },
    {
      name: 'clientName',
      value: '',
    },
    {
      name: 'summary',
      value: '[]',
    },
    {
      name: 'deductibleAmount',
      value: '385',
      validator: [
        {
          fn: 'required',
          args: ['Dit veld is verplicht'],
        },
      ],
      options: [
        {
          label: '€385',
          value: '385',
        },
        {
          label: '€485',
          value: '485',
        },
        {
          label: '€585',
          value: '585',
        },
        {
          label: '€685',
          value: '685',
        },
        {
          label: '€785',
          value: '785',
        },
        {
          label: '€885',
          value: '885',
        },
      ],
    },
    {
      name: 'highestDeductibleAmountFromProducts',
      value: '0',
    },
    {
      name: 'highestDeductibleAmountFromProductsLoading',
      value: 'false',
    },
    {
      name: 'flow',
      value: '',
    },
  ],
};

export default getUserInput;
